import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { trackEvent } from '../lib/fbPixel';
interface FinalCTAProps {
  onCTAClick: () => void;
}
type PackId = 'profesional' | 'elite';
export function FinalCTA({
  onCTAClick
}: FinalCTAProps) {
  const [selected, setSelected] = useState<PackId>('elite');
  const packs = [{
    id: 'profesional' as PackId,
    icon: '📘',
    title: 'PACK PROFESIONAL',
    desc: '12 Tomos + 6 Bonus',
    oldPrice: '$29.990',
    price: '$18.990',
    isElite: false
  }, {
    id: 'elite' as PackId,
    icon: '🏆',
    title: 'PACK ÉLITE TOTAL',
    desc: '12 Tomos + 6 Bonus + 2 Élite',
    oldPrice: '$49.990',
    price: '$27.990',
    savings: 'AHORRÁS $9.000',
    isElite: true
  }];
  const ctaText = selected === 'elite' ? '→ SÍ, QUIERO EL PACK ÉLITE TOTAL' : '→ SÍ, QUIERO EL PACK PROFESIONAL';
  const handlePurchaseClick = () => {
    const pack = packs.find(p => p.id === selected);
    const value = selected === 'elite' ? 27990 : 18990;
    trackEvent('InitiateCheckout', {
      content_name: pack?.title ?? 'VOLEY 360',
      content_category: 'Pack',
      content_ids: [selected],
      value,
      currency: 'ARS',
      num_items: 1
    });
    onCTAClick();
  };
  return <section className="w-full px-4 py-20 md:py-24 bg-bg-primary border-t border-border-card" data-id="element-108">
      <div className="max-w-3xl mx-auto" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-111">
            ⏰ El precio de lanzamiento cierra en:
          </h2>
          <CountdownTimer data-id="element-112" />
        </motion.div>

        <div className="space-y-4 mb-8 mt-12" data-id="element-113">
          {packs.map((pack, index) => {
          const isSelected = selected === pack.id;
          return <motion.button key={pack.id} type="button" onClick={() => setSelected(pack.id)} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`w-full text-left bg-bg-card rounded-card p-5 md:p-6 relative transition-all ${isSelected ? 'border-2 border-orange' : 'border-2 border-border-card hover:border-text-secondary/40'}`} style={isSelected && pack.isElite ? {
            boxShadow: '0 0 30px rgba(168, 216, 234, 0.25)'
          } : undefined} data-id="element-114">
                {pack.isElite && <div className="absolute -top-3 right-4" data-id="element-115">
                    <div className="px-3 py-1 bg-gold text-bg-primary font-black rounded-md text-xs flex items-center gap-1 shadow-lg" data-id="element-116">
                      <Sparkles className="w-3 h-3" data-id="element-117" />
                      MÁS ELEGIDO
                    </div>
                  </div>}

                <div className="flex items-center gap-4" data-id="element-118">
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-all ${isSelected ? 'border-orange' : 'border-text-secondary/50'}`} data-id="element-119">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-orange" data-id="element-120" />}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-121">
                    <div className="flex items-center gap-2 mb-1" data-id="element-122">
                      <span className="text-xl" data-id="element-123">{pack.icon}</span>
                      <h3 className="font-black text-base md:text-lg" data-id="element-124">
                        {pack.title}
                      </h3>
                    </div>
                    <p className="text-sm text-text-secondary" data-id="element-125">{pack.desc}</p>
                    {pack.savings && <div className="inline-block mt-2 px-3 py-1 bg-orange/15 border border-orange/40 rounded-full text-orange text-xs font-bold" data-id="element-126">
                        {pack.savings}
                      </div>}
                  </div>

                  <div className="text-right flex-shrink-0" data-id="element-127">
                    <div className="text-sm text-text-secondary line-through" data-id="element-128">
                      {pack.oldPrice}
                    </div>
                    <div className="text-2xl md:text-3xl font-black" data-id="element-129">
                      {pack.price}
                    </div>
                    <div className="text-xs text-text-secondary" data-id="element-130">ARS</div>
                  </div>
                </div>
              </motion.button>;
        })}
        </div>

        <motion.button onClick={handlePurchaseClick} whileHover={{
        scale: 1.01
      }} whileTap={{
        scale: 0.99
      }} className="w-full py-5 md:py-6 bg-orange hover:bg-orange/90 text-bg-primary text-base md:text-xl font-black rounded-card shadow-2xl transition-colors mb-10" data-id="element-131">
          {ctaText}
        </motion.button>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-132">
          <p className="text-xl md:text-2xl font-bold leading-relaxed text-text-secondary" data-id="element-133">
            🏐 <span className="text-white" data-id="element-134">VOLEY 360</span> — El sistema de
            entrenamiento N°1 para profes de vóley argentinos.
            <br data-id="element-135" />
            <span className="text-text-secondary text-base md:text-lg" data-id="element-136">
              Porque preparar un buen entrenamiento no debería costarte todas
              las noches de la semana.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}